import {Box, Button, Tooltip} from "@mui/material"
import {useState} from "react"

import {AlertAlign} from "../../../shared/component/box/AlertAlign"
import {KeyEnterInput} from "../../../shared/component/input/KeyEnterInput"
import {SxPropsMap} from "../../../shared/helper/HelperType"
import {useRouterUserPassword} from "../api/UserHook"

const SX: SxPropsMap = {
    box: {display: "flex", flexDirection: "column", gap: 2},
    inputs: {display: "flex", flexDirection: "column", gap: 1.5},
    button: {padding: "5px"},
}

export function UserAccountPassword() {
    const [previousPassword, setPreviousPassword] = useState("")
    const [newPassword, setNewPassword] = useState("")
    const [repeat, setRepeat] = useState("")
    const updatePassword = useRouterUserPassword(handleUpdated)

    return (
        <Box sx={SX.box}>
            <AlertAlign text={renderDescription()}/>
            <Box sx={SX.inputs}>
                <KeyEnterInput
                    label={"Current password"}
                    value={previousPassword}
                    hidden
                    onChange={(e) => setPreviousPassword(e.target.value)}
                />
                <KeyEnterInput
                    label={"New password"}
                    value={newPassword}
                    hidden
                    onChange={(e) => setNewPassword(e.target.value)}
                />
                <KeyEnterInput
                    label={getRepeatLabel()}
                    value={repeat}
                    hidden
                    error={isMismatched()}
                    onChange={(e) => setRepeat(e.target.value)}
                    onEnterPress={handleUpdate}
                />
            </Box>
            {renderButton()}
        </Box>
    )

    function renderButton() {
        return (
            <Tooltip title={"Replace your password with the new one"} placement={"top"} arrow disableInteractive>
                <Box component={"span"}>
                    <Button
                        sx={SX.button}
                        fullWidth={true}
                        loading={updatePassword.isPending}
                        disabled={!isComplete()}
                        onClick={handleUpdate}
                    >
                        Change password
                    </Button>
                </Box>
            </Tooltip>
        )
    }

    function renderDescription() {
        return (
            "Avoid using the same password across multiple accounts. " +
            "For better security, use a unique password with letters, numbers, and special characters."
        )
    }

    function getRepeatLabel() {
        return isMismatched() ? "Repeat new password - they do not match" : "Repeat new password"
    }

    function handleUpdate() {
        if (!isComplete()) return
        updatePassword.mutate({previousPassword, newPassword})
    }

    function handleUpdated() {
        setPreviousPassword("")
        setNewPassword("")
        setRepeat("")
    }

    function isComplete() {
        return !!previousPassword && !!newPassword && newPassword === repeat
    }

    function isMismatched() {
        return repeat !== "" && newPassword !== repeat
    }
}
